import { render, staticRenderFns } from "./grasping_rules_stores.vue?vue&type=template&id=0cbcb0cf&scoped=true"
import script from "./grasping_rules_stores.vue?vue&type=script&lang=js"
export * from "./grasping_rules_stores.vue?vue&type=script&lang=js"
import style0 from "./grasping_rules_stores.vue?vue&type=style&index=0&id=0cbcb0cf&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbcb0cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbcb0cf')) {
      api.createRecord('0cbcb0cf', component.options)
    } else {
      api.reload('0cbcb0cf', component.options)
    }
    module.hot.accept("./grasping_rules_stores.vue?vue&type=template&id=0cbcb0cf&scoped=true", function () {
      api.rerender('0cbcb0cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/kms/views/grasping_rules/form/components/grasping_rules_stores.vue"
export default component.exports